module.exports = __webpack_public_path__ + "static/MC_MARK_SIX-5411eb1282110aa39382b41ff27b7dbc.png";